import { createContext, useContext } from 'react';

/** Densidade das linhas de uma listagem. */
export type TableDensity = 'comfortable' | 'compact';

export interface TableDensityContexto {
  density: TableDensity;
  setDensity: (valor: TableDensity) => void;
  alternar: () => void;
}

export const TableDensityContext = createContext<TableDensityContexto | null>(null);

/**
 * Sem provedor (TableDensityProvider), devolve o padrao confortavel — a
 * tabela funciona fora de um provedor de densidade, so nao lembra a
 * preferencia.
 */
export function useTableDensity(): TableDensityContexto {
  const contexto = useContext(TableDensityContext);
  if (contexto) {
    return contexto;
  }
  return {
    density: 'comfortable',
    setDensity: () => undefined,
    alternar: () => undefined,
  };
}
